import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useCompany } from "../../components/context/CompanyContext";
import Loading from "../../components/loading/loading";
import "../../global.css";
import { userRequest } from "../../requestMethods";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import Modal from "@mui/material/Modal";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import Container from "@mui/material/Container";
import { formatPricing, formatPricingDatabase, validarEmail, validarCPF } from "../../util/helper";
import { DeleteOutline } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import CustomGrid from "../../components/grid/CustomGrid";

const style = {
  background: "white",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%,-50%)",
  padding: "60px",
  borderRadius: "15px",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
};

export default function User() {
  const location = useLocation();
  const id = location.pathname.split("/")[3];
  const [user, setUser] = useState({});
  const [inputs, setInputs] = useState({});
  const [userRep, setUserRep] = useState([]);
  const [reps, setReps] = useState([]);
  const [rep, setRep] = useState();
  const [cargo, setCargo] = useState("");
  const [newManaged, setNewManaged] = useState();
  const [admin, setAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [existUsername, setExistUsername] = useState();
  const { companyId } = useCompany();
  const currentUser = useSelector((state) => state.user.currentUser);
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState();
  const [stories, setStories] = useState([]);
  const [store, setStore] = useState();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [target, setTarget] = useState();
  const [campaign, setCampaign] = useState();
  const [campaigns, setCampaigns] = useState();
  const nav = useNavigate();

  useEffect(() => {
    if (companyId > 0) {
      getAllCompaign();
      getStories();
      getReps();
    }
    if (id !== "new") {
      getUser();
      getUsers();
      getUserReps();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, companyId]);

  useEffect(() => {
    if (user) {
      if (user.position) {
        setCargo(user.position);
      }
      if (user.isAdmin) setAdmin(true);
      if (user.storeId) {
        setStore(user.storeId);
      }

      if (user.target && user.campaignId) {
        setTarget(user.target);
        setCampaign(user.campaignId);
      }
    }
  }, [user]);

  const getAllCompaign = async () => {
    const res = await userRequest.get(`${companyId}/campaign/active`);

    setCampaigns(res.data);
  };

  const getUserReps = async () => {
    try {
      const res = await userRequest.get(`${companyId}/usersRep/user/${id}`);

      setUserRep(res.data);
    } catch {
      console.log();
    }
  };
  const getReps = async () => {
    try {
      const res = await userRequest.get(`${companyId}/usersRep/active`);

      setReps(res.data);
    } catch {
      console.log();
    }
  };
  const getUser = async () => {
    try {
      const res = await userRequest.get(`${companyId}/users/find/${id}`);

      // eslint-disable-next-line array-callback-return
      res.data.map((item) => {
        setUser(item);
      });
    } catch {
      console.log();
    }
  };
  const getUsername = async () => {
    try {
      const res = await userRequest.get(
        `${companyId}/users/username/${inputs.username}`,
      );

      if (Object.keys(res.data).length > 0) {
        setExistUsername(true);
      } else {
        setExistUsername(false);
      }
    } catch {
      console.log();
    }
  };

  const validate = () => {
    if (inputs.username === "" || inputs.username === undefined) {
      Swal.fire("Atenção!", "O campo Username deve ser preenchido.", "warning");
      return false;
    }

    if (existUsername) {
      Swal.fire("Atenção!", "Username existente.", "warning");
      return false;
    }
    if (inputs.name === "" || inputs.name === undefined) {
      Swal.fire("Atenção!", "O campo Nome deve ser preenchido.", "warning");

      return false;
    }
    if (inputs.cpf === "" || inputs.cpf === undefined) {
      Swal.fire("Atenção!", "O campo CPF deve ser preenchido.", "warning");
      return false;
    }
    if (!validarCPF(inputs.cpf)) {
      Swal.fire("Atenção!", "CPF inválido.", "warning");
      return false;
    }
    if (inputs.email === "" || inputs.email === undefined) {
      Swal.fire("Atenção!", "O campo Email deve ser preenchido.", "warning");
      return false;
    }
    if (!validarEmail(inputs.email)) {
      Swal.fire("Atenção!", "E-mail inválido.", "warning");
      return false;
    }

    if (inputs.contact === "" || inputs.contact === undefined) {
      Swal.fire("Atenção!", "O campo Telefone deve ser preenchido.", "warning");

      return false;
    }
    if (inputs.address === "" || inputs.address === undefined) {
      Swal.fire("Atenção!", "O campo Endereço deve ser preenchido.", "warning");

      return false;
    }
    if (!cargo) {
      Swal.fire("Atenção!", "O campo Cargo deve ser selecionado.", "warning");

      return false;
    }

    return true;
  };
  const updateClick = async (event) => {
    setIsLoading(true);
    if (id !== "new") {
      UpdateUser();
    } else {
      if (validate()) {
        InserirUser();
      }
    }
    setIsLoading(false);
  };
  const UpdateUser = async (event) => {
    try {
      const res = await userRequest.put(`${companyId}/users/${id}`, {
        userId: currentUser.userId,
        name: inputs.name,
        email: inputs.email,
        contact: inputs.contact,
        position: cargo,
        username: inputs.username,
        ...(inputs.password && { password: inputs.password }),
        cpf: inputs.cpf,
        isAdmin: admin,
        address: inputs.address,
        lastUserUpdate: currentUser.userId,
        storeId: store,
        target: { target: target, campaignId: campaign },
      });

      if (Object.keys(res.data).length > 0) {
        Swal.fire("Parabéns!", "Usuário alterado com sucesso!", "success");
        nav(`../users`);
      } else {
        Swal.fire("Atenção!", "Erro ao alterar usuário!", "error");
      }
    } catch (error) {}
  };
  const InserirUser = async () => {
    try {
      const res = await userRequest.post(
        `${companyId}/users/registerEmployee`,
        [
          {
            name: inputs.name,
            email: inputs.email,
            contact: inputs.contact,
            position: cargo,
            username: inputs.username,
            password: inputs.password,
            cpf: inputs.cpf,
            isAdmin: admin,
            address: inputs.address,
            lastUserUpdate: currentUser.userId,
            storeId: store,
            target: { target: target, campaignId: campaign },
          },
        ],
      );

      if (Object.keys(res.data).length > 0) {
        Swal.fire("Parabéns!", "Usuário inserido com sucesso!", "success");
        nav(`../users`);
      } else {
        Swal.fire("Atenção!", "Erro ao inserir usuário!", "error");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getUsers = async () => {
    try {
      let url = `${companyId}/users`;

      const res = await userRequest.get(url);

      setUsers(res.data);
    } catch (error) {
      console.log(error.code);
    }
  };
  const getStories = async () => {
    try {
      let url = `${companyId}/store`;

      const res = await userRequest.get(url);

      setStories(res.data);
    } catch (error) {
      console.log(error.code);
    }
  };
  const handleChange = (e) => {
    setInputs((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };
  const handleBlur = (e) => {
    getUsername();
  };
  const handleChangePosition = (e) => {
    setCargo(e.target.value);
  };
  const handleChangeNewManaged = (e) => {
    setNewManaged(e.target.value);
  };
  const handleChangeAdmin = (e) => {
    //setAdmin(e.target.value);
    setAdmin(e.target.checked);
  };
  const handleChangeTarget = (e) => {
    setTarget(e.target.value);
  };
  const handleChangeCampaign = (e) => {
    setCampaign(e.target.value);
  };
  const handleChangeRep = (e) => {
    setRep(e.target.value);
  };
  const transfUser = async (event) => {
    try {
      const res = await userRequest.put(`${companyId}/users/${id}`, {
        lastUserUpdate: currentUser.userId,
      });
      const resC = await userRequest.put(
        `${companyId}/customers/transfer/${id}`,
        { managedBy: newManaged },
      );
      if (Object.keys(res.data).length > 0) {
        Swal.fire("Parabéns!", "Clientes transferidos com sucesso!", "success");
        nav(`../users`);
      } else {
        Swal.fire("Atenção!", "Erro ao alterar usuário!", "error");
      }
    } catch (error) {}
  };
  const addRep = async (event) => {
    try {
      const res = await userRequest.post(
        `${companyId}/usersRep/registerUserRep`,
        {
          userId: id,
          userRepId: rep,
        },
      );
      if (Object.keys(res.data).length > 0) {
        Swal.fire(
          "Parabéns!",
          "Representate cadastrado com sucesso!",
          "success",
        );
        getUserReps();
      } else {
        Swal.fire("Atenção!", "Erro ao cadastrar representante!", "error");
      }
    } catch (error) {}
  };
  const handleChangeStore = (e) => {
    setStore(e.target.value);
  };
  const deleteRep = async (cp) => {
    const res = await userRequest.put(`${companyId}/usersRep/${cp}`, {
      deleted: new Date(),
      lastUserUpdate: currentUser.userId,
    });

    if (res.data > 0) {
      getUserReps();
    } else {
      Swal.fire("Atenção!", "Erro ao excluir desconto!", "error");
    }
  };
  const onButtonDeleteClick = async (e, row) => {
    if (currentUser.isAdmin) {
      Swal.fire({
        title: "Tem certeza que deseja excluir?",
        text: "Você não poderá reverter isso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#EE8253",
        confirmButtonText: "Sim, excluir!",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          deleteRep(row);
        }
      });
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para excluir a loja!",
        "warning",
      );
    }
  };
  const columns = [
    {
      field: "userRepId",
      type: "number",
      align: "left",
      headerName: "Código Representante",
      width: 200,
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "name",
      type: "text",
      align: "left",
      headerName: "Nome",
      width: 300,
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "deletar",
      type: "text",
      headerName: "",
      width: 80,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
      display: "flex",
      renderCell: (params) => {
        if (!params.row.deleted) {
          return (
            <IconButton
              onClick={(e) => onButtonDeleteClick(e, params.row.storeId)}
            >
              <DeleteOutline />
            </IconButton>
          );
        }
      },
    },
  ];
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div style={style}>
          <table className="table">
            <tr>
              <td align="left" width="100%">
                <tr>
                  <td>
                    <TransferWithinAStationIcon />
                  </td>
                  <td>
                    <tr className="labelTitle">Tranferência de clientes</tr>
                  </td>
                </tr>
              </td>
              <td align="left" width="0%">
                {" "}
              </td>
            </tr>
          </table>
          <table
            cellSpacing="1"
            cellPadding="2"
            align="center"
            className="table"
          >
            <tr>
              <td align="left" className="left">
                De:
              </td>
              <td align="left" className="right_black_List">
                {id !== "new" && user ? user.username || "" : ""}
              </td>
            </tr>
            <tr>
              <td align="left" className="left">
                Para:
              </td>
              <td align="left" className="right_black_List">
                <select
                  className="cust-select"
                  name="newManaged"
                  id="newManaged"
                  onChange={handleChangeNewManaged}
                  value={newManaged}
                >
                  <option value=""></option>
                  {users
                    ? users.map((item) => (
                        <option key={item.userId} value={item.userId}>
                          {item.name}
                        </option>
                      ))
                    : false}
                </select>
              </td>
            </tr>
          </table>
          <div
            style={{
              marginTop: 16,
              display: "flex",
              gap: 8,
              justifyContent: "center",
            }}
          >
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<SaveIcon />}
              onClick={transfUser}
            >
              Tranferir
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleClose}>
              Cancelar
            </Button>
          </div>
        </div>
      </Modal>

      {isLoading ? (
        <Loading />
      ) : (
        <div className="cust-page">
          <div className="cust-title">
            {id !== "new" && user ? "Editar Usuário" : "Novo Usuário"}
          </div>

          {/* Acesso */}
          <div className="cust-card">
            <div className="cust-section-header">Acesso</div>
            <div className="cust-fields">
              <div className="cust-field">
                <label className="cust-label">Username</label>
                <input
                  type="text"
                  className="cust-input"
                  name="username"
                  defaultValue={id !== "new" && user ? user.username || "" : ""}
                  onChange={handleChange}
                  maxLength="20"
                  onBlur={handleBlur}
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Senha</label>
                <input
                  type="text"
                  name="password"
                  defaultValue=""
                  className="cust-input"
                  onChange={handleChange}
                  maxLength="20"
                />
              </div>
            </div>
          </div>

          {/* Dados Pessoais */}
          <div className="cust-card">
            <div className="cust-section-header">Dados Pessoais</div>
            <div className="cust-fields cust-fields-3">
              <div className="cust-field">
                <label className="cust-label">Nome</label>
                <input
                  type="text"
                  name="name"
                  defaultValue={id !== "new" && user ? user.name || "" : ""}
                  className="cust-input"
                  onChange={handleChange}
                  maxLength="200"
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">CPF</label>
                <input
                  type="number"
                  name="cpf"
                  className="cust-input"
                  defaultValue={id !== "new" && user ? user.cpf || "" : ""}
                  onChange={handleChange}
                  maxLength="11"
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="cust-input"
                  defaultValue={id !== "new" && user ? user.email || "" : ""}
                  onChange={handleChange}
                  maxLength="200"
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Telefone</label>
                <input
                  type="number"
                  name="contact"
                  onChange={handleChange}
                  className="cust-input"
                  defaultValue={id !== "new" && user ? user.contact || "" : ""}
                  maxLength="12"
                />
              </div>
              <div className="cust-field full">
                <label className="cust-label">Endereço</label>
                <input
                  type="text"
                  name="address"
                  onChange={handleChange}
                  className="cust-input"
                  defaultValue={id !== "new" && user ? user.address || "" : ""}
                  maxLength="200"
                />
              </div>
            </div>
          </div>

          {/* Configurações */}
          <div className="cust-card">
            <div className="cust-section-header">Configurações</div>
            <div className="cust-fields">
              <div className="cust-field">
                <label className="cust-label">Cargo</label>
                <select
                  className="cust-select"
                  name="position"
                  id="position"
                  onChange={handleChangePosition}
                  value={cargo}
                >
                  <option value=""></option>
                  <option value="Administrador">Administrador</option>
                  <option value="Gerente">Gerente</option>
                  <option value="Vendedor(a)">Vendedor(a)</option>
                  <option value="Estoquista">Estoquista</option>
                  <option value="Outros">Outros</option>
                </select>
              </div>
              <div className="cust-field">
                <label className="cust-label">Loja</label>
                <select
                  className="cust-select"
                  name="store"
                  id="store"
                  onChange={handleChangeStore}
                  value={store ? store : ""}
                >
                  <option value=""></option>
                  {stories
                    ? stories.map((item) => (
                        <option key={item.storeId} value={item.storeId}>
                          {item.store}
                        </option>
                      ))
                    : false}
                </select>
              </div>
            </div>
          </div>

          {/* Metas */}
          <div className="cust-card">
            <div className="cust-section-header">Metas</div>
            <div className="cust-fields">
              <div className="cust-field">
                <label className="cust-label">Meta de Venda</label>
                <input
                  type="text"
                  name="target"
                  className="cust-input"
                  defaultValue={target ? formatPricing(target) : ""}
                  onChange={handleChangeTarget}
                  onKeyDown={(e) => {
                    if (e.keyCode === 8 || e.keyCode === 46)
                      setTarget(undefined);
                  }}
                />
              </div>
              <div className="cust-field">
                <label className="cust-label">Campanha</label>
                <select
                  className="cust-select"
                  name="campaign"
                  id="campaign"
                  onChange={handleChangeCampaign}
                  value={campaign ? campaign : ""}
                >
                  <option value=""></option>
                  {campaigns
                    ? campaigns.map((item) => (
                        <option key={item.campaignId} value={item.campaignId}>
                          {item.title}
                        </option>
                      ))
                    : false}
                </select>
              </div>
            </div>
          </div>

          {/* Representantes */}
          <div className="cust-card">
            <div className="cust-section-header">Representantes</div>
            <div className="cust-fields">
              <div className="cust-field">
                <label className="cust-label">Representante</label>
                <select
                  className="cust-select"
                  name="rep"
                  id="rep"
                  onChange={handleChangeRep}
                >
                  <option value=""></option>
                  {reps
                    ? reps.map((item) => (
                        <option key={item.userRepId} value={item.userRepId}>
                          {item.name}
                        </option>
                      ))
                    : false}
                </select>
              </div>
              <div
                className="cust-field"
                style={{ justifyContent: "flex-end" }}
              >
                <label className="cust-label">&nbsp;</label>
                <Button
                  variant="outlined"
                  color="secondary"
                  size="small"
                  startIcon={<SaveIcon />}
                  onClick={addRep}
                >
                  Adicionar Representante
                </Button>
              </div>
            </div>
            <div style={{ padding: "0 16px 16px" }}>
              <div style={{ height: 300 }}>
                <CustomGrid
                  gridId="userRep"
                  getRowId={(row) => row.userRepId}
                  rows={userRep}
                  columns={columns}
                  tableHeight="300px"
                />
              </div>
            </div>
          </div>

          {/* Outras Configurações */}
          <div className="cust-card">
            <div className="cust-section-header">Outras Configurações</div>
            <div className="cust-switch-row">
              <label className="cust-label" style={{ marginBottom: 0 }}>
                Administrador
              </label>
              <Switch checked={admin} onChange={(e) => handleChangeAdmin(e)} />
            </div>
            <div style={{ padding: "0 16px 16px" }}>
              <Button
                size="small"
                variant="outlined"
                startIcon={<TransferWithinAStationIcon />}
                onClick={handleOpen}
              >
                Transferência Cliente
              </Button>
            </div>
          </div>
          <div className="cust-footer">
            <Button variant="outlined" size="small" onClick={() => nav(-1)}>
              Voltar
            </Button>
            <Button variant="contained" color="secondary" size="small" startIcon={<SaveIcon />} onClick={updateClick}>
              {id !== "new" && user ? "Alterar" : "Cadastrar"}
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
